import { IconLogoWhatsapp } from '@gazin/ecommerce-ui'
import { getWhatsAppSacUrl } from 'src/util/whatsapp'
import * as S from './styles'

type WhatsAppButtonProps = {
  label?: string
  dataTestId?: string
}

/**
 * Ponto de entrada fixo do atendimento via WhatsApp. Diferente do popup
 * flutuante (`whatsAppPopup`), este botão não pode ser dispensado pelo cliente,
 * então o canal continua acessível independente do estado do popup.
 */
export default function WhatsAppButton({
  label = 'Chamar no WhatsApp',
  dataTestId = 'whatsapp-button',
}: WhatsAppButtonProps) {
  return (
    <S.WhatsAppLink
      href={getWhatsAppSacUrl()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={dataTestId}
    >
      <IconLogoWhatsapp width="1.5rem" height="1.5rem" />
      {label}
    </S.WhatsAppLink>
  )
}
